import { FC } from "react";
import OverwriteLookNamesWithMaterialNames from "../../public/icons/Overwrite_Targets_with_MaterialNames.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const OverwriteLookNamesWithMaterialNamesIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><OverwriteLookNamesWithMaterialNames/></span>;
